import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { FormWrapper, HeaderAndFormWrapper, Main, PageWrapper } from '../login/index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import RegisterWithDetailsStepDetails from './details';
import RegisterWithDetailsStepRegister from './register';

export default function RegisterWithDetailsPage() {
  const location = useLocation();

  return (
    <PageWrapper>
      <HeaderAndFormWrapper>
        <Header />
        <FormWrapper>
          <Main>
            <Heading align="center">Register</Heading>
            <Routes>
              <Route path="register" element={<RegisterWithDetailsStepRegister />} />
              <Route path="details" element={<RegisterWithDetailsStepDetails />} />
              <Route
                path="*"
                element={
                  <Navigate
                    to={{
                      pathname: 'register',
                      search: location.search,
                    }}
                    state={location.state}
                  />
                }
              />
            </Routes>
            <p>
              <T>Already have an account?</T>{' '}
              <Link to="/login" state={location.state}>
                <T>Login</T>
              </Link>
              .
            </p>
          </Main>
        </FormWrapper>
      </HeaderAndFormWrapper>
      <Footer />
    </PageWrapper>
  );
}
